<template>
	<ul class="list-none">
		<li
			v-for="item of items"
			:key="item"
			class="flex gap-6"
		>
			<span>
				<AtomFontAwesome
					:icon
					class="size-7 text-purple-600"
				/>
			</span>
			<span>
				{{ item }}
			</span>
		</li>
	</ul>
</template>

<script setup lang="ts">
import type { FontAwesomeIconType } from '~/plugins/fontawesome';

const {
	items,
	icon = 'fa-check',
} = defineProps<{
	items: string[];
	icon?: FontAwesomeIconType;
}>();
</script>
